import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { UserService } from "../_services/user.service";
import { environment } from "../../environments/environment";

export const authGuard: CanActivateFn = () => {
    if (!environment.production) return true;
    const router = inject(Router);
    return inject(UserService).getCurrentUser()
        .then(() => true)
        .catch(() => {
            router.navigate(["/login"]);
            return false;
        });
};
